<template>
  <div class="update-info">
    <div class="info-panel-header">
      New version is available.
    </div>
    <div class="info-panel-description">
      <div style="font-size: 16px;">
        {{ 'An update of the app has been downloaded. Just click the button below to apply the latest changes.' }}
      </div>
      <GenericButton
        @click="$emit('updateApp')"
        text="UPDATE APPLICATION"
        full-width
      />
    </div>
    <div class="info-panel-image">
      <img
        src="@/assets/img/icons/update-green-pipboy.png"
        width="90"
        height="90"
      >
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue"
import GenericButton from "../GenericButton.vue";
export default defineComponent({
    name: "UpdateExists",
    emits: ["updateApp"],
    components: { GenericButton }
})
</script>

<style scoped>
.info-panel-header {
  font-size: 25px;
  text-align: left;
  margin-top: 5px;
  margin-left: 15px;
  width: 92%;
  border-bottom: 2px ridge var(--text-green);
  color: var(--text-green);
}
.info-panel-description {
  color: var(--text-green);
  text-align: justify;
  width: 65%;
  margin-top: 10px;
  padding-left: 15px;
  font-family: var(--font-family-fixedsys);
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.info-panel-image {
  position: absolute;
  top: 50px;
  right: 25px;
}
.update-info {
  width: 92%;
  background-color: rgba(59, 68, 57, 0.707);
  border: 2px ridge rgb(59, 216, 35);
  border-radius: 5px;
}
</style>